import { render, staticRenderFns } from "./CrowdloanCard.vue?vue&type=template&id=44bfdb0f&scoped=true&"
import script from "./CrowdloanCard.vue?vue&type=script&lang=js&"
export * from "./CrowdloanCard.vue?vue&type=script&lang=js&"
import style0 from "./CrowdloanCard.vue?vue&type=style&index=0&id=44bfdb0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bfdb0f",
  null
  
)

export default component.exports